import _extends from "@swc/helpers/src/_extends.mjs";
// DS: I3.2
import React from 'react';
import IconWrap from '../IconWrap';
const AddPlus = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 12 12"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 5.9a1 1 0 01-1 1H7V11a1 1 0 01-.875.992L6 12a1 1 0 01-.993-.883L5 11V6.9H1a1 1 0 010-2l4-.002V1a1 1 0 01.875-.992L6 0a1 1 0 01.993.883L7 1v3.898l4 .002a1 1 0 011 1z"
    })));
AddPlus.displayName = 'AddPlus';
export default AddPlus;
